import { z } from 'zod';
import { createModel, QueryMany, QueryOne, partySchema } from '../../common';
import { emailSchema, nameSchema, phoneSchema } from '../../validation';
import { contactClientSchema } from './contact-client.model';
import { UTagSharedSchema } from '../utag';
/**
 * `contact db model`
 *
 * these are saved contact that can belong to a carrier - business - third party customer - individual customer
 */
export const ContactSchema = createModel({
  /** contact name */
  name: nameSchema,
  phone: phoneSchema,
  email: emailSchema.optional(),
  /**
   * @TBC --- we need to finish the position of the contact.
   * the customer that this contact belongs to.
   *
   * If empty then, this contact has no customer.
   */
  /** sales - operation  */
  // position: nameSchema.optional(),
  org: partySchema,
  isOwnContact: z.boolean(),
  /**
   * the unified `Client` rows this contact is linked to.
   *
   * Each entry carries the full multi-role snapshot of the linked Client.
   */
  clients: z.array(contactClientSchema).default([]),
  UTags: z.array(UTagSharedSchema),
});

/**
 * `contact db model`
 *
 * these are saved contact that can belong to a carrier - business - third party customer - individual customer
 */
export type Contact = z.infer<typeof ContactSchema.model>;
export type ContactData = z.infer<typeof ContactSchema.data>;
export type ContactPartial = z.infer<typeof ContactSchema.partial>;
export type ContactQueryMany = QueryMany<Contact>;
export type ContactQueryOne = QueryOne<Contact>;
